import { render, staticRenderFns } from "./il-textarea-editor.vue?vue&type=template&id=30ef3bdb"
import script from "./il-textarea-editor.vue?vue&type=script&lang=ts"
export * from "./il-textarea-editor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports